import { useEffect } from 'react';
import shallow from 'zustand/shallow';

import { useAsync, useGetQuery } from '../../../../lib/client/hooks';

import * as services from '../services';
import * as TYPES from '../constants';
import { useRombel } from '.';
import { useToast } from '@chakra-ui/react';

export function useListRombel(params) {
  const { data, status, errorMessage, isIdle, refetch, isFetching } =
    useGetQuery({
      queryKey: params.queryKey || TYPES.FETCH_ROMBEL,
      queryFn: async () => {
        delete params?.queryKey;
        const response = await services.listRombel(params);
        return response.data;
      },
      enabled: params?.enabled || true,
    });

  return {
    data,
    status,
    errorMessage,
    isIdle,
    refetch,
    isFetching,
  };
}
export function useListStudentRombel(params) {
  // console.log({ params });
  const { data, status, errorMessage, isIdle, refetch, isFetching } =
    useGetQuery({
      queryKey: TYPES.FETCH_STUDENT_ROMBEL,
      queryFn: async () => {
        const response = await services.getStudentRombel(params);
        return response.data;
      },
    });

  return {
    data,
    status,
    errorMessage,
    isIdle,
    refetch,
    isFetching,
  };
}

export function useListStundentNonRombel(params) {
  const { data, status, errorMessage, isIdle, refetch, isFetching } =
    useGetQuery({
      queryKey: TYPES.FETCH_STUDENT_NO_ROMBEL,
      queryFn: async () => {
        const response = await services.getStudenNontRombel(params);
        return response.data;
      },
    });

  return {
    data,
    status,
    errorMessage,
    isIdle,
    refetch,
    isFetching,
  };
}

export function useCreateRombel() {
  const { execute, status, value, errorMessage, fieldErrors } = useAsync(
    services.createRombel,
  );

  const [setResult] = useRombel((state) => [state.setResult], shallow);

  useEffect(() => {
    if (status === 'resolved') {
      setResult(value.data);
    }
  }, [status]);

  async function create(payload) {
    try {
      await execute(payload);
    } catch (err) {
      console.error(err);
    }
  }

  return [create, status, errorMessage, fieldErrors];
}

export function useNextGrafeRombel() {
  const { execute, status, value, errorMessage, fieldErrors } = useAsync(
    services.nextGradeRombel,
  );

  const [setResult] = useRombel((state) => [state.setResult], shallow);
  const toast = useToast();

  useEffect(() => {
    if (status === 'resolved') {
      setResult(value.data);
      toast({
        title: 'Sukses Menaikan Kelas ',
        status: 'success',
        duration: 7000,
      });
    }

    if (status == 'rejected') {
      toast({
        title: 'Error Menaikan Kelas ',
        status: 'error',
        duration: 2000,
        description: errorMessage,
      });
    }
  }, [status]);

  async function nextGrade(payload) {
    try {
      await execute(payload);
    } catch (err) {
      console.error(err);
    }
  }

  return { nextGrade, status, errorMessage, fieldErrors };
}

export function useUpdateRombel() {
  const { execute, status, value, errorMessage, fieldErrors } = useAsync(
    services.updateRombel,
  );

  const [setResult] = useRombel((state) => [state.setResult], shallow);

  useEffect(() => {
    if (status === 'resolved') {
      setResult(value.data);
    }
  }, [status]);

  async function update(payload) {
    try {
      await execute(payload);
    } catch (err) {
      console.error(err);
    }
  }

  return [update, status, errorMessage, fieldErrors];
}

export function useShowRombel(id) {
  const { data, status, errorMessage, isIdle, refetch } = useGetQuery({
    queryKey: TYPES.FETCH_ROMBEL,
    queryFn: async () => {
      const response = await services.showRombel(id);
      return response.data;
    },
  });

  return {
    data,
    status,
    errorMessage,
    isIdle,
    refetch,
  };
}

export function useRemoveRombel() {
  const { execute, status, value, errorMessage, fieldErrors } = useAsync(
    services.removeRombel,
  );

  const [setResult] = useRombel((state) => [state.setResult], shallow);

  useEffect(() => {
    if (status === 'resolved') {
      setResult(value.data);
    }
  }, [status]);

  async function remove(id) {
    try {
      await execute(id);
    } catch (err) {
      console.error(err);
    }
  }

  return [remove, status, errorMessage, fieldErrors];
}

export function useGetStudent() {
  const [idRombel] = useRombel((state) => [state.idRombel], shallow);
  const [idStudents] = useRombel((state) => [state.idStudents], shallow);

  const { data, statusGet, errorMessage, isIdle, refetch } = useGetQuery({
    queryKey: TYPES.FETCH_STUDENT,
    queryFn: async () => {
      if (idRombel) {
        const response = await services.listStudent({
          idRombel: idRombel,
          idStudents: idStudents,
        });
        return response.data;
      }
    },
  });

  useEffect(() => {
    if (idRombel) {
      refetch();
    }
  }, [idRombel]);

  return {
    data,
    statusGet,
    errorMessage,
    isIdle,
    refetch,
  };
}

export function useAddStudent() {
  const { execute, status, value, errorMessage, fieldErrors } = useAsync(
    services.addStudent,
  );

  const [setResult] = useRombel((state) => [state.setResult], shallow);

  useEffect(() => {
    if (status === 'resolved') {
      setResult(value.data);
    }
  }, [status]);

  async function add(payload) {
    try {
      await execute(payload);
    } catch (err) {
      console.error(err);
    }
  }

  return [add, status, errorMessage, fieldErrors];
}

export function useImportStudent() {
  const { execute, status, value, errorMessage, fieldErrors } = useAsync(
    services.importStudent,
  );

  async function importData(payload) {
    try {
      return await execute(payload);
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  return {
    importData,
    status,
    value,
    errorMessage,
    fieldErrors,
  };
}
